import { RegistrationStatus } from "../../types/shared.types";

export const getStatusIcon = (status: RegistrationStatus): string => {
  switch (status) {
    case RegistrationStatus.Registered:
      return "✓";
    case RegistrationStatus.Tentative:
      return "?";
    case RegistrationStatus.Declined:
      return "✗";
    case RegistrationStatus.Cancelled:
      return "✗";
    case RegistrationStatus.Attended:
      return "✓";
    default:
      return "";
  }
};

export const getStatusClass = (status: RegistrationStatus): string => {
  switch (status) {
    case RegistrationStatus.Registered:
      return "is-registered";
    case RegistrationStatus.Tentative:
      return "is-tentative";
    case RegistrationStatus.Declined:
      return "is-declined";
    case RegistrationStatus.Cancelled:
      return "is-cancelled";
    case RegistrationStatus.Attended:
      return "is-attended";
    default:
      return "";
  }
};

export const getStatusColor = (status: RegistrationStatus): string => {
  switch (status) {
    case RegistrationStatus.Registered:
      return "#22c55e";
    case RegistrationStatus.Tentative:
      return "#f59e0b";
    case RegistrationStatus.Declined:
      return "#6b7280";
    case RegistrationStatus.Cancelled:
      return "#ef4444";
    case RegistrationStatus.Attended:
      return "#3b82f6";
    default:
      return "#6b7280";
  }
};

export const getStatusLabel = (status: RegistrationStatus): string => {
  switch (status) {
    case RegistrationStatus.Registered:
      return "Confirmed ✓";
    case RegistrationStatus.Tentative:
      return "Tentative";
    case RegistrationStatus.Declined:
      return "Declined";
    case RegistrationStatus.Cancelled:
      return "Cancelled";
    case RegistrationStatus.Attended:
      return "Attended ✓";
    default:
      return status;
  }
};

export const getSubmitButtonText = (
  isSubmitting: boolean,
  status: RegistrationStatus,
  isUpdateMode: boolean,
): string => {
  if (isSubmitting) return "Submitting...";

  switch (status) {
    case RegistrationStatus.Registered:
      return isUpdateMode ? "Save Changes" : "Confirm Registration";
    case RegistrationStatus.Tentative:
      return isUpdateMode ? "Save as Tentative" : "Submit as Tentative";
    case RegistrationStatus.Declined:
      return isUpdateMode ? "Save Decline" : "Submit Decline";
    default:
      return isUpdateMode ? "Save Changes" : "Submit";
  }
};

export const getResponseOptions = () => [
  {
    value: RegistrationStatus.Registered,
    label: "Accept",
    color: getStatusColor(RegistrationStatus.Registered),
    icon: getStatusIcon(RegistrationStatus.Registered),
  },
  {
    value: RegistrationStatus.Tentative,
    label: "Tentative",
    color: getStatusColor(RegistrationStatus.Tentative),
    icon: getStatusIcon(RegistrationStatus.Tentative),
  },
  {
    value: RegistrationStatus.Declined,
    label: "Decline",
    color: getStatusColor(RegistrationStatus.Declined),
    icon: getStatusIcon(RegistrationStatus.Declined),
  },
];

export const STATUS_CONFIG = {
  [RegistrationStatus.Registered]: {
    icon: getStatusIcon(RegistrationStatus.Registered),
    cssClass: getStatusClass(RegistrationStatus.Registered),
    color: getStatusColor(RegistrationStatus.Registered),
    label: getStatusLabel(RegistrationStatus.Registered),
  },
  [RegistrationStatus.Tentative]: {
    icon: getStatusIcon(RegistrationStatus.Tentative),
    cssClass: getStatusClass(RegistrationStatus.Tentative),
    color: getStatusColor(RegistrationStatus.Tentative),
    label: getStatusLabel(RegistrationStatus.Tentative),
  },
  [RegistrationStatus.Declined]: {
    icon: getStatusIcon(RegistrationStatus.Declined),
    cssClass: getStatusClass(RegistrationStatus.Declined),
    color: getStatusColor(RegistrationStatus.Declined),
    label: getStatusLabel(RegistrationStatus.Declined),
  },
  [RegistrationStatus.Cancelled]: {
    icon: getStatusIcon(RegistrationStatus.Cancelled),
    cssClass: getStatusClass(RegistrationStatus.Cancelled),
    color: getStatusColor(RegistrationStatus.Cancelled),
    label: getStatusLabel(RegistrationStatus.Cancelled),
  },
  [RegistrationStatus.Attended]: {
    icon: getStatusIcon(RegistrationStatus.Attended),
    cssClass: getStatusClass(RegistrationStatus.Attended),
    color: getStatusColor(RegistrationStatus.Attended),
    label: getStatusLabel(RegistrationStatus.Attended),
  },
} as const;

export const getStatusConfig = (status: RegistrationStatus) => {
  return (
    STATUS_CONFIG[status] || {
      icon: "",
      cssClass: "",
      color: "#6b7280",
      label: status,
    }
  );
};
